/**
 * Formats a number as a full comma-separated value according to Indian or International system
 * Used for tooltips to show the complete unrounded value
 */

export function formatFullValue(value: number, currency = "INR"): string {
  // Handle edge cases
  if (value === 0 || !value) return "0";
  
  // Convert to absolute value for formatting, keep track of sign
  const isNegative = value < 0;
  const absoluteValue = Math.abs(value);
  
  // Use Indian number system for INR, International for others
  const useIndianSystem = currency === "INR";
  
  let formattedValue: string;
  
  if (useIndianSystem) {
    // Indian number system: 1,00,000 (1 lakh), 1,00,00,000 (1 crore)
    formattedValue = absoluteValue.toLocaleString("en-IN");
  } else {
    // International number system: 1,000,000 (1 million)
    formattedValue = absoluteValue.toLocaleString("en-US");
  }
  
  // Add negative sign back if needed
  return isNegative ? `-${formattedValue}` : formattedValue;
}
